import { useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useState } from 'react'
import Agree from './Agree'
import BarLoader from 'react-spinners/BarLoader'
import ShareBtn from '../ShareBtn'

function App({ isDkabio, setIsDkabio }) {
  const [ac, setAc] = useState(null)
  const [tk, setTk] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [showShareBtn, setShowShareBtn] = useState(true)
  // let { pid } = useParams()
  // pid = 'P' + pid.split('p')[1]
  // 特殊設定
  // const { pathname } = useLocation()
  // const pid = 'P' + pathname.toLowerCase().split('/p')[1]
  // const { pathname } = useLocation()
  // // console.log('pathname', pathname)
  // const pid = pathname
  //   .split('/')
  //   .filter((segment) => segment)[0]
  //   .toUpperCase()

  // const [serial_number, setSerial_number] = useState('')
  // const { serial_num: routeSerialNumber } = useParams()

  // useEffect(() => {
  //   if (routeSerialNumber !== undefined) {
  //     setSerial_number(routeSerialNumber)
  //   }
  // }, [])

  const [searchParams] = useSearchParams()
  const location = useLocation()
  const [pid, setPid] = useState(location.pathname.split('/')[1].toUpperCase())
  const [serialNum, setSerialNum] = useState(
    searchParams.get('serial_num') || null
  )

  useEffect(() => {
    // 從路徑中提取 pid
    const newPid = location.pathname.split('/')[1].toUpperCase()
    setPid(newPid)

    // 獲取查詢參數
    const nweSerialNum = searchParams.get('serial_num')
    setSerialNum(nweSerialNum)
    const userId = searchParams.get('user_id')

    // console.log('Project ID:', pid) // 現在會輸出: P230914102305
    // console.log('Serial Number:', serialNum) // 會輸出: 789
    // console.log('User ID:', userId)
  }, [searchParams, location.pathname])

  // console.log('routeSerialNumber', routeSerialNumber)

  // const navigate = useNavigate()

  // useEffect(() => {
  //   switch (routeSerialNumber) {
  //     case 'closed':
  //       navigate(`/${pid}/closed`)
  //       break
  //     case 'done':
  //       navigate(`/${pid}/done`)
  //       break
  //     case 'submitFail':
  //       navigate(`/${pid}/submitFail`)
  //       break
  //     case 'notFound':
  //       navigate(`/${pid}/notFound`)
  //       break
  //     case 'formatError':
  //       navigate(`/${pid}/formatError`)
  //       break
  //     case 'success':
  //       navigate(`/${pid}/success`)
  //       break
  //     default:
  //       // 視為 serial number
  //       navigate(`/${pid}/${serial_number}`)
  //   }
  // }, [pid, serial_number, navigate])

  // pid = 'P' + pid.split('/p')[1]
  // const pid = 'P231206105643'
  // 隨機一份問卷
  // const pidObj = {
  //   0: 'P230919184319',
  //   1: 'P230815121716',
  //   2: 'P230815121714',
  // }

  // const [randomPid, setrandomPid] = useState('')
  // useEffect(() => {
  //   const ord = Math.floor(Math.random() * 3)
  //   setrandomPid(pidObj[ord])
  // }, [])
  // console.log('randomPid', randomPid)

  // BarLoader
  const actualInnerWidth = document.body.clientWidth - 20
  // share
  const shareUrl = `${window.location.origin}/${pid}`

  return (
    <>
      <BarLoader
        cssOverride={{ overflow: 'hidden', position: 'fixed', zIndex: '1021' }}
        color="#19b394"
        width={actualInnerWidth}
        loading={isLoading}
      />

      <Agree
        setIsLoading={setIsLoading}
        pid={pid}
        setAc={setAc}
        setTk={setTk}
        ac={ac}
        tk={tk}
        setShowShareBtn={setShowShareBtn}
        serial_num={serialNum}
        isDkabio={isDkabio}
        setIsDkabio={setIsDkabio}
        // setCompletionMessage={setCompletionMessage}
      />
      <ShareBtn showShareBtn={showShareBtn} shareUrl={shareUrl} />
    </>
  )
}

export default App
